import z from 'zod';

/** Printed / emailed / exported (API field `execution_status`). */
export const executionStatusSchema = z.enum(['printed', 'emailed', 'exported']);
export type ExecutionStatus = z.infer<typeof executionStatusSchema>;

/** Option object type for execution status. */
export type ExecutionStatusOption = {
  name: string;
  value: ExecutionStatus;
};

export const executionStatusOptions: ExecutionStatusOption[] = [
  { name: 'Printed', value: 'printed' },
  { name: 'Emailed', value: 'emailed' },
  { name: 'Exported', value: 'exported' },
] as const;

export const executionStatusValues = new Set<ExecutionStatus>(executionStatusOptions.map((option) => option.value));

/** Billing lifecycle (API field `status`). */
export const invoiceLifecycleStatusSchema = z.enum([
  'open',
  'paid',
  'partially paid',
  'past due',
  'uncollectable',
  'void',
  'write-off',
]);
export type InvoiceLifecycleStatus = z.infer<typeof invoiceLifecycleStatusSchema>;

export type InvoiceLifecycleStatusOption = {
  name: string;
  value: InvoiceLifecycleStatus;
};

export const invoiceLifecycleStatusOptions: InvoiceLifecycleStatusOption[] = [
  { name: 'Open', value: 'open' },
  { name: 'Paid', value: 'paid' },
  { name: 'Partially Paid', value: 'partially paid' },
  { name: 'Past Due', value: 'past due' },
  { name: 'Uncollectable', value: 'uncollectable' },
  { name: 'Void', value: 'void' },
  { name: 'Write-Off', value: 'write-off' },
] as const;

export const invoiceLifecycleStatusValues = new Set<InvoiceLifecycleStatus>(
  invoiceLifecycleStatusOptions.map((option) => option.value)
);
